import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';

const lumaSpinVariants = cva(
  'relative aspect-square animate-in fade-in duration-300',
  {
    variants: {
      size: {
        sm: 'w-5',    // 20px - for buttons and inline use
        md: 'w-10',   // 40px - default medium size
        lg: 'w-[65px]', // 65px - large/full-page loading
      },
    },
    defaultVariants: {
      size: 'md',
    },
  }
);

export interface LumaSpinProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof lumaSpinVariants> {}

const LumaSpin = React.forwardRef<HTMLDivElement, LumaSpinProps>(
  ({ className, size, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(lumaSpinVariants({ size }), className)}
        role="status"
        aria-label="Loading"
        {...props}
      >
        <span
          className="absolute rounded-[50px] shadow-[inset_0_0_0_3px] shadow-gray-800 dark:shadow-gray-100 transition-all"
          style={{
            animation: 'loaderAnim 2.5s cubic-bezier(0.4, 0, 0.2, 1) infinite',
          }}
        />
        <span
          className="absolute rounded-[50px] shadow-[inset_0_0_0_3px] shadow-gray-800 dark:shadow-gray-100 transition-all"
          style={{
            animation: 'loaderAnim 2.5s cubic-bezier(0.4, 0, 0.2, 1) infinite',
            animationDelay: '-1.25s',
          }}
        />
      </div>
    );
  }
);

LumaSpin.displayName = 'LumaSpin';

export { LumaSpin };
export default LumaSpin;
